import React from "react";
import logo from "../assets/images/Logo/web_logo.png";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { useNavigate } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import avtar from "../assets/images/Avatar/01.png";
import bgImg from "../assets/images/other/bg.png";
import { useSelector } from "react-redux";

const ProfileDone = () => {
  const navigate = useNavigate();

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const handleNav = () => {
    if (isAuthenticated) {
      // alert("Done")
      localStorage.removeItem("setup_tab");
      navigate("/set-up");
    }
  };
  return (
    <>
      <section className="min-h-screen relative overflow-hidden flex items-center justify-center px-4 sm:px-6 lg:px-20 bg-gray-50 lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100">
        <DecorativeSquares />
        {/* Card */}
        <div className="w-full max-w-md bg-transparent md:bg-white rounded-2xl shadow-none md:shadow-lg px-6 py-8 sm:px-8 sm:py-10 space-y-6 ">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center gap-2">
            <img
              src={logo}
              alt="web_logo"
              className="w-20 h-20 object-contain"
            />
            <p className="text-gray-400 text-sm text-center">
              You Cook, We Manage the Rest
            </p>
          </div>

          {/* Card */}
          {/* Inner Avatar Card */}
          <div className="mx-auto max-w-xs  bg-white rounded-2xl shadow-md px-6 py-8 flex flex-col items-center gap-5">
            {/* Avatar wrapper */}
            <div className="h-2 w-1/2 bg-slate-100 rounded-full"></div>
            <div className="relative">
              {/* Soft circle bg */}
              <div className="absolute inset-0 rounded-full bg-orange-100 scale-110"></div>

              {/* Avatar */}
              <img
                src={avtar}
                alt="avatar"
                className="relative w-28 h-28 object-contain"
              />
            </div>

            {/* Fake text lines */}
            <div className="w-full flex flex-col items-center gap-3 mt-2">
              <div className="h-2 w-3/4 bg-slate-100 rounded-full"></div>
              <div className="h-2 w-2/3 bg-slate-100 rounded-full"></div>
              <div className="h-2 w-1/2 bg-slate-100 rounded-full"></div>
            </div>
          </div>

          <div className="mt-8 space-y-3 text-center">
            <h2 className="text-2xl font-semibold text-center text-gray-800">
              Success! Your profile is all set up.
            </h2>
            <p className="text-[#242021] text-base">
              Let's set up your tiffin services quickly
            </p>
          </div>
          {/* Button */}
          <PrimaryBtn
            btnName="Get Started"
            clickEvent={handleNav}
            extraClass="mt-8 ml-2"
          />
        </div>
      </section>
    </>
  );
};

export default ProfileDone;
